export const fmtUSD = (n) =>
  `$${(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const fmtSPURR = (n) =>
  (n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
